<template>
  <div class="py-tool">
    <!-- Input -->
    <div class="py-input-section">
      <div class="py-input-label">
        <span class="py-dot" />
        {{ $t('tool.PinyinConverter.input') }}
      </div>
      <el-input
        v-model="input" type="textarea" :rows="4"
        :placeholder="$t('tool.PinyinConverter.phInput')"
        class="py-textarea" @input="convert"
      />
      <div class="py-options">
        <span class="py-options-label">{{ $t('tool.PinyinConverter.mode') }}</span>
        <el-radio-group v-model="mode" size="small" @change="convert">
          <el-radio-button label="tone">Chóngqìng</el-radio-button>
          <el-radio-button label="number">Chong2qing4</el-radio-button>
          <el-radio-button label="plain">Chongqing</el-radio-button>
        </el-radio-group>
        <span class="py-stats" v-if="stats">{{ stats }}</span>
      </div>
    </div>

    <!-- Output -->
    <div class="py-output" v-if="output">
      <div class="py-output-header">
        <span class="py-output-title">{{ $t('tool.PinyinConverter.output') }}</span>
        <el-button size="mini" plain icon="el-icon-document-copy" @click="copyOutput">{{ $t("common.action.copy") }}</el-button>
      </div>
      <div class="py-result-text">{{ output }}</div>
    </div>

    <!-- Character tokens -->
    <div class="py-tokens-section" v-if="tokens.length">
      <div class="py-tokens-header">
        <span class="py-tokens-title">{{ $t('tool.PinyinConverter.tokens') }}</span>
        <span class="py-tokens-hint">
          <span class="py-hint-dot py-multi-dot" /> {{ $t('tool.PinyinConverter.multiChar') }}
          <span class="py-hint-dot py-normal-dot" /> {{ $t('tool.PinyinConverter.identified') }}
        </span>
      </div>
      <div class="py-tokens">
        <div
          v-for="(t, i) in tokens" :key="i"
          class="py-token" :class="{ 'py-multi': t.multi, 'py-unknown': t.py === '?' }"
        >
          <span class="py-token-char">{{ t.char }}</span>
          <span class="py-token-py">{{ t.py }}</span>
        </div>
      </div>
    </div>

    <div class="py-empty" v-if="!output && !input">{{ $t('tool.PinyinConverter.emptyHint') }}</div>
  </div>
</template>

<script>
var DICT = {
  '的':'de5','一':'yi1','是':'shi4','在':'zai4','不':'bu4','了':'le5','有':'you3','和':'he2','人':'ren2','这':'zhe4',
  '中':'zhong1','大':'da4','为':'wei4','上':'shang4','个':'ge4','国':'guo2','我':'wo3','以':'yi3','要':'yao4','他':'ta1',
  '时':'shi2','来':'lai2','用':'yong4','们':'men5','生':'sheng1','到':'dao4','作':'zuo4','地':'di4','于':'yu2','出':'chu1',
  '会':'hui4','可':'ke3','也':'ye3','你':'ni3','对':'dui4','能':'neng2','而':'er2','下':'xia4','过':'guo4','子':'zi3',
  '说':'shuo1','产':'chan3','种':'zhong3','面':'mian4','方':'fang1','后':'hou4','多':'duo1','定':'ding4','行':'xing2',
  '学':'xue2','法':'fa3','所':'suo3','民':'min2','得':'de2','经':'jing1','十':'shi2','三':'san1','之':'zhi1','进':'jin4',
  '着':'zhe5','等':'deng3','部':'bu4','度':'du4','家':'jia1','电':'dian4','里':'li3','如':'ru2','水':'shui3','化':'hua4',
  '高':'gao1','自':'zi4','二':'er4','理':'li3','起':'qi3','小':'xiao3','物':'wu4','现':'xian4','实':'shi2','加':'jia1',
  '量':'liang4','都':'dou1','两':'liang3','体':'ti3','制':'zhi4','机':'ji1','当':'dang1','使':'shi3','点':'dian3','从':'cong2',
  '业':'ye4','本':'ben3','去':'qu4','把':'ba3','性':'xing4','应':'ying1','开':'kai1','它':'ta1','合':'he2','因':'yin1',
  '只':'zhi3','些':'xie1','想':'xiang3','前':'qian2','文':'wen2','没':'mei2','天':'tian1','看':'kan4','提':'ti2','四':'si4',
  '头':'tou2','同':'tong2','新':'xin1','相':'xiang1','全':'quan2','比':'bi3','通':'tong1','很':'hen3','心':'xin1','与':'yu3',
  '名':'ming2','力':'li4','问':'wen4','公':'gong1','见':'jian4','军':'jun1','无':'wu2','长':'chang2','手':'shou3','知':'zhi1',
  '山':'shan1','东':'dong1','西':'xi1','南':'nan2','北':'bei3','海':'hai3','城':'cheng2','市':'shi4','年':'nian2','月':'yue4',
  '日':'ri4','明':'ming2','平':'ping2','关':'guan1','正':'zheng4','外':'wai4','将':'jiang1','内':'nei4','老':'lao3','道':'dao4',
  '工':'gong1','马':'ma3','还':'hai2','意':'yi4','光':'guang1','少':'shao3','门':'men2','最':'zui4','话':'hua4','员':'yuan2',
  '安':'an1','美':'mei3','第':'di4','金':'jin1','回':'hui2','被':'bei4','此':'ci3','反':'fan3','其':'qi2','发':'fa1',
  '成':'cheng2','政':'zheng4','变':'bian4','世':'shi4','重':'zhong4','好':'hao3','次':'ci4','给':'gei3','才':'cai2',
  '向':'xiang4','五':'wu3','各':'ge4','战':'zhan4','立':'li4','或':'huo4','万':'wan4','几':'ji3','社':'she4','口':'kou3',
  '活':'huo2','原':'yuan2','数':'shu4','总':'zong3','题':'ti2','建':'jian4','展':'zhan3','那':'na4','代':'dai4','林':'lin2',
  '处':'chu4','领':'ling3','白':'bai2','教':'jiao4','路':'lu4','花':'hua1','张':'zhang1','先':'xian1','干':'gan4','色':'se4',
  '走':'zou3','常':'chang2','较':'jiao4','真':'zhen1','又':'you4','什':'shen2','么':'me5','入':'ru4','区':'qu1','史':'shi3',
  '受':'shou4','今':'jin1','改':'gai3','统':'tong3','器':'qi4','件':'jian4','任':'ren4','更':'geng4','强':'qiang2','认':'ren4',
  '放':'fang4','解':'jie3','接':'jie1','做':'zuo4','示':'shi4','必':'bi4','界':'jie4','许':'xu3','场':'chang3','别':'bie2',
  '条':'tiao2','件':'jian4','声':'sheng1','越':'yue4','且':'qie3','完':'wan2','华':'hua2','每':'mei3','最':'zui4','认':'ren4',
  '车':'che1','计':'ji4','造':'zao4','算':'suan4','清':'qing1','志':'zhi4','程':'cheng2','指':'zhi3','权':'quan2','求':'qiu2',
  '管':'guan3','根':'gen1','论':'lun4','百':'bai3','六':'liu4','切':'qie4','信':'xin4','务':'wu4','具':'ju4','八':'ba1',
  '共':'gong4','联':'lian2','据':'ju4','深':'shen1','精':'jing1','农':'nong2','确':'que4','连':'lian2','广':'guang3','近':'jin4',
  '九':'jiu3','整':'zheng3','风':'feng1','米':'mi3','类':'lei4','空':'kong1','集':'ji2','转':'zhuan3','王':'wang2','传':'chuan2',
  '江':'jiang1','李':'li3','七':'qi1','究':'jiu1','半':'ban4','况':'kuang4','至':'zhi4','则':'ze2','周':'zhou1','网':'wang3',
  '爱':'ai4','太':'tai4','书':'shu1','青':'qing1','司':'si1','即':'ji2','龙':'long2','火':'huo3','打':'da3','字':'zi4',
  '千':'qian1','河':'he2','单':'dan1','乐':'le4','快':'kuai4','刘':'liu2','飞':'fei1','黑':'hei1','红':'hong2','远':'yuan3',
  '服':'fu2','界':'jie4','黄':'huang2','层':'ceng2','收':'shou1','验':'yan4','参':'can1','己':'ji3','卫':'wei4','士':'shi4',
  '死':'si3','写':'xie3','片':'pian4','草':'cao3','楼':'lou2','记':'ji4','雪':'xue3','拿':'na2','元':'yuan2','钱':'qian2',
  '答':'da2','笑':'xiao4','船':'chuan2','花':'hua1','师':'shi1','英':'ying1','语':'yu3','语':'yu4','云':'yun2','星':'xing1',
  '鱼':'yu2','送':'song4','音':'yin1','园':'yuan2','汽':'qi4','坐':'zuo4','必':'bi4','每':'mei3','饱':'bao3','干':'gan1',
  '树':'shu4','码':'ma3','谢':'xie4','读':'du2','早':'zao3','房':'fang2','阳':'yang2','节':'jie2','夫':'fu1','热':'re4',
  '识':'shi2','短':'duan3','脸':'lian3','欢':'huan1','石':'shi2','士':'shi4','急':'ji2','足':'zu2','银':'yin2','独':'du2',
  '川':'chuan1','歌':'ge1','容':'rong2','喝':'he1','古':'gu3','汉':'han4','奇':'qi2','息':'xi1','晚':'wan3','类':'lei4',
  '器':'qi4','烟':'yan1','追':'zhui1','首':'shou3','李':'li3','饭':'fan4','治':'zhi4','黄':'huang2','春':'chun1','备':'bei4',
  '英':'ying1','沙':'sha1','苦':'ku3','似':'si4','永':'yong3','秦':'qin2','够':'gou4','首':'shou3','脑':'nao3','富':'fu4',
  '熟':'shou2','票':'piao4','良':'liang2','铁':'tie3','球':'qiu2','印':'yin4','约':'yue1','跳':'tiao4','油':'you2','环':'huan2',
  '香':'xiang1','绿':'lv4','助':'zhu4','商':'shang1','京':'jing1','嘴':'zui3','底':'di3','课':'ke4','饭':'fan4','况':'kuang4',
  '雨':'yu3','草':'cao3','远':'yuan3','格':'ge2','急':'ji2','般':'ban1','富':'fu4','群':'qun2','零':'ling2','注':'zhu4',
  '宁':'ning2','落':'luo4','乐':'yue4','段':'duan4','半':'ban4','冷':'leng3','困':'kun4','停':'ting2','离':'li2','句':'ju4',
  '牌':'pai2','包':'bao1','痛':'tong4','顿':'dun4','私':'si1','银':'yin2','唱':'chang4','忙':'mang2','流':'liu2','尽':'jin4',
  '破':'po4','降':'jiang4','微':'wei1','引':'yin3','忘':'wang4','专':'zhuan1','静':'jing4','备':'bei4','举':'ju3','湖':'hu2',
  '夏':'xia4','选':'xuan3','建':'jian4','签':'qian1','忙':'mang2','贵':'gui4','号':'hao4','孙':'sun1','句':'ju4','吸':'xi1',
  '练':'lian4','副':'fu4','材':'cai2','古':'gu3','篇':'pian1','啦':'la5','宜':'yi2','官':'guan1','懂':'dong3','获':'huo4',
  '留':'liu2','夏':'xia4','酒':'jiu3','密':'mi4','座':'zuo4','课':'ke4','铁':'tie3','汉':'han4','旅':'lv3','虽':'sui1',
  '保':'bao3','忘':'wang4','娘':'niang2','诚':'cheng2','顺':'shun4','嘴':'zui3','够':'gou4','纸':'zhi3','跳':'tiao4','蓝':'lan2',
  '际':'ji4','伤':'shang1','温':'wen1','掉':'diao4','提':'ti2','财':'cai2','司':'si1','灭':'mie4','红':'hong2','州':'zhou1',
  '岁':'sui4','爱':'ai4','春':'chun1','江':'jiang1','造':'zao4','读':'du2','句':'ju4','敢':'gan3','毛':'mao2','级':'ji2',
  '教':'jiao1','戏':'xi4','麦':'mai4','界':'jie4','飞':'fei1','拿':'na2','哥':'ge1','坏':'huai4','突':'tu1','屋':'wu1',
  '换':'huan4','达':'da2','争':'zheng1','究':'jiu1','站':'zhan4','沙':'sha1','习':'xi2','源':'yuan2','季':'ji4','站':'zhan4',
  '完':'wan2','第':'di4','零':'ling2','步':'bu4','养':'yang3','标':'biao1','望':'wang4','价':'jia4','居':'ju1','奇':'qi2',
  '校':'xiao4','转':'zhuan3','冲':'chong1','灵':'ling2','程':'cheng2','急':'ji2','睡':'shui4','爷':'ye2','整':'zheng3','牛':'niu2',
  '根':'gen1','步':'bu4','释':'shi4','清':'qing1','娘':'niang2','服':'fu4','脑':'nao3','研':'yan2','街':'jie1','称':'cheng1',
  '夜':'ye4','鱼':'yu2','际':'ji4','密':'mi4','交':'jiao1','买':'mai3','浪':'lang4','刻':'ke4','班':'ban1','饭':'fan4',
  '冷':'leng3','户':'hu4','姐':'jie3','围':'wei2','脑':'nao3','灵':'ling2','秋':'qiu1','刻':'ke4','批':'pi1','掌':'zhang3',
  '让':'rang4','奇':'qi2','治':'zhi4','制':'zhi4','区':'qu1','堂':'tang2','鸟':'niao3','弹':'tan2','骨':'gu3','顶':'ding3',
  '哭':'ku1','伤':'shang1','练':'lian4','居':'ju1','实':'shi2','买':'mai3','司':'si1','练':'lian4','号':'hao2','块':'kuai4',
  '贵':'gui4','掉':'diao4','朝':'chao2','旧':'jiu4','推':'tui1','款':'kuan3','静':'jing4','雪':'xue3','夏':'xia4','清':'qing1',
  '试':'shi4','散':'san4','片':'pian1','证':'zheng4','港':'gang3','园':'yuan2','页':'ye4','屋':'wu1','田':'tian2','趣':'qu4',
  '败':'bai4','草':'cao3','响':'xiang3','注':'zhu4','伟':'wei3','护':'hu4','群':'qun2','够':'gou4','宁':'ning2','选':'xuan3',
  '广':'guang3','片':'pian4','急':'ji2','远':'yuan3','刘':'liu2','族':'zu2','养':'yang3','雪':'xue3','养':'yang3','够':'gou4',
  '哥':'ge1','伤':'shang1','双':'shuang1','倒':'dao3','刻':'ke4','富':'fu4','故':'gu4','维':'wei2','李':'li3','钱':'qian2',
  '落':'la4','异':'yi4','除':'chu2','牌':'pai2','获':'huo4','块':'kuai4','唱':'chang4','静':'jing4','吹':'chui1','称':'chen4',
  '童':'tong2','广':'guang3','故':'gu4','宣':'xuan1','抓':'zhua1','背':'bei1','烧':'shao1','穿':'chuan1','云':'yun2','园':'yuan2',
  '养':'yang3','映':'ying4','精':'jing1','观':'guan1','园':'yuan2','静':'jing4','伤':'shang1','势':'shi4','唱':'chang4','背':'bei4',
  '重':'chong2','庆':'qing4','美':'mei3','丽':'li4','山':'shan1'
}

var MULTI = {
  '重':{ '重庆':'chong2', '重量':'zhong4', '重要':'zhong4', '重复':'chong2'},
  '长':{ '重庆':'chang2', '长大':'zhang3', '长期':'chang2', '成长':'cheng2 zhang3'},
  '行':{ '银行':'hang2', '行走':'xing2', '行动':'xing2'},
  '乐':{ '音乐':'yue4', '快乐':'le4'},
  '朝':{ '朝代':'chao2', '朝向':'chao2', '朝阳':'zhao1'},
  '大':{ '大夫':'dai4', '大学':'da4'}
}

function getPinyin(char, context, mode) {
  var pinyin = DICT[char]
  if (!pinyin) return char

  var tone = pinyin.charAt(pinyin.length - 1)
  var base = pinyin.slice(0, -1)

  function applyTone(s, t) {
    var toneMarks = {
      'a':['ā','á','ǎ','à','a'],'o':['ō','ó','ǒ','ò','o'],'e':['ē','é','ě','è','e'],
      'i':['ī','í','ǐ','ì','i'],'u':['ū','ú','ǔ','ù','u'],'v':['ǖ','ǘ','ǚ','ǜ','ü']
    }
    var tn = parseInt(t)
    if (isNaN(tn) || tn < 1 || tn > 4) return s
    var idx = tn - 1
    var pos = s.indexOf('a'); if (pos === -1) pos = s.indexOf('o')
    if (pos === -1) pos = s.indexOf('e')
    if (pos === -1) { pos = s.length - 1; for (var k = s.length-1; k >= 0; k--) { if ('iuv'.indexOf(s[k]) !== -1) { pos = k; break } } }
    var v = s[pos]
    var marked = toneMarks[v] ? toneMarks[v][idx] : v
    return s.slice(0, pos) + marked + s.slice(pos + 1)
  }

  if (mode === 'tone') return applyTone(base, tone)
  if (mode === 'number') return base + tone
  return base
}

export default {
  name:'PinyinConverterTool',
  props:{ config:{ type:Object, default:function(){ return {} } } },
  data:function(){
    return { input:'重庆是一座美丽的山城', mode:'tone', output:'', tokens:[], multiCount:0 }
  },
  computed:{
    stats:function(){
      if (!this.tokens.length) return ''
      var parts = [this.$t('tool.PinyinConverter.charsCount', { n: this.tokens.length })]
      if (this.multiCount) parts.push(this.$t('tool.PinyinConverter.multiCount', { n: this.multiCount }))
      return parts.join(' · ')
    }
  },
  created:function(){ this.convert() },
  methods:{
    convert:function(){
      var text = this.input.trim()
      if (!text) { this.output = ''; this.tokens = []; this.multiCount = 0; return }

      var chars = text.split('')
      var result = []
      var tokens = []
      var mc = 0

      for (var i = 0; i < chars.length; i++) {
        var ch = chars[i]
        if (DICT[ch]) {
          var py = getPinyin(ch, null, this.mode)
          var multi = false

          if (MULTI[ch]) {
            var ctx = chars.slice(Math.max(0,i-1), Math.min(chars.length,i+3)).join('')
            for (var c in MULTI[ch]) {
              if (ctx.indexOf(c) !== -1) {
                var mp = MULTI[ch][c].split(' ')[0]
                var tone = mp.charAt(mp.length-1)
                var base = mp.slice(0,-1)
                if (this.mode === 'tone') {
                  py = (function(s,t){
                    var vp = Math.max(s.indexOf('a'), s.indexOf('o'), s.indexOf('e'))
                    if (vp === -1) vp = s.length-1
                    var marks = {'a':['ā','á','ǎ','à'],'o':['ō','ó','ǒ','ò'],'e':['ē','é','ě','è'],'i':['ī','í','ǐ','ì'],'u':['ū','ú','ǔ','ù']}
                    var v = s[vp]; var tn = parseInt(t)-1
                    return s.slice(0,vp) + (marks[v] ? marks[v][tn] : v) + s.slice(vp+1)
                  })(base, tone)
                } else if (this.mode === 'number') {
                  py = base + tone
                } else {
                  py = base
                }
                multi = true; mc++
                break
              }
            }
          }

          result.push(py)
          tokens.push({ char:ch, py:py, multi:multi })
        } else if (/[一-鿿]/.test(ch)) {
          result.push(ch)
          tokens.push({ char:ch, py:'?', multi:false })
        } else {
          result.push(ch)
          if (ch.trim()) tokens.push({ char:ch, py:ch, multi:false })
        }
      }

      this.output = result.join(' ')
      this.tokens = tokens
      this.multiCount = mc
    },
    copyOutput:function(){
      navigator.clipboard.writeText(this.output); this.$message.success(this.$t('tool.PinyinConverter.copied'))
    },
    doAction:function(a){
      if (a === 'clear') { this.input = ''; this.output = ''; this.tokens = []; this.multiCount = 0 }
      if (a === 'copy') this.copyOutput()
    }
  }
}
</script>

<style scoped>
.py-tool { width: 100%; }

/* input */
.py-input-section { margin-bottom: 20px; }
.py-input-label { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #606266; margin-bottom: 10px; }
.py-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,.4); }
.py-textarea >>> textarea { font-size: 15px !important; line-height: 1.8 !important; }
.py-options { display: flex; align-items: center; gap: 10px; margin-top: 12px; flex-wrap: wrap; }
.py-options-label { font-size: 12px; font-weight: 600; color: #909399; flex-shrink: 0; }
.py-stats { font-size: 12px; color: #b0b8c4; margin-left: auto; }

/* output */
.py-output { background: #f8f9fb; border: 1px solid #e4e7ed; border-radius: 10px; overflow: hidden; margin-bottom: 20px; }
.py-output-header { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; background: #eef1f6; border-bottom: 1px solid #e4e7ed; }
.py-output-title { font-size: 12px; font-weight: 600; color: #606266; }
.py-result-text { padding: 14px 18px; font-size: 18px; color: #303133; line-height: 2; word-break: break-all; font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif; }

/* tokens */
.py-tokens-section { margin-bottom: 20px; }
.py-tokens-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.py-tokens-title { font-size: 13px; font-weight: 600; color: #606266; }
.py-tokens-hint { display: flex; align-items: center; gap: 14px; font-size: 11px; color: #b0b8c4; }
.py-hint-dot { display: inline-block; width: 8px; height: 8px; border-radius: 2px; margin-right: 4px; }
.py-multi-dot { background: #e6a23c; }
.py-normal-dot { background: #d0ddf8; }

.py-tokens { display: flex; flex-wrap: wrap; gap: 6px; }
.py-token {
  display: inline-flex; flex-direction: column; align-items: center;
  padding: 8px 12px; min-width: 46px;
  background: #fff; border: 1px solid #e4e7ed; border-radius: 8px;
  transition: all .15s;
}
.py-token-char { font-size: 20px; font-weight: 700; color: #1a1f36; line-height: 1.2; }
.py-token-py { font-size: 12px; color: #909399; margin-top: 2px; font-weight: 500; }
.py-token.py-multi { border-color: #e6a23c; background: #fffdf5; }
.py-token.py-multi .py-token-py { color: #e6a23c; font-weight: 700; }
.py-token.py-unknown { border-color: #f56c6c; background: #fff5f5; }
.py-token.py-unknown .py-token-py { color: #f56c6c; }

.py-empty { text-align: center; padding: 40px; color: #c0c4cc; font-size: 14px; }
</style>
